import { render, staticRenderFns } from "./VSort.vue?vue&type=template&id=3e0b9cf5&"
import script from "./VSort.vue?vue&type=script&lang=ts&"
export * from "./VSort.vue?vue&type=script&lang=ts&"
import style0 from "./VSort.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports